import { AuthService } from './services/auth.service'
import { createAuthErrorLink } from './auth-error-link'
import { ApplicationConfig, inject } from '@angular/core'
import { getAuth, getIdToken } from '@angular/fire/auth'

import { Router } from '@angular/router'
import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular'
import { HttpLink } from 'apollo-angular/http'

import { environment } from '../environments/environment'

export function apolloOptionsFactory(): ApolloClient.Options {
  const httpLink = inject(HttpLink)
  const router = inject(Router)
  const authService = inject(AuthService)
  const errorLink = createAuthErrorLink(authService, router)

  const auth = setContext(async () => {
    const authGeneration = authService.generation
    const user = getAuth().currentUser
    try {
      if (user) {
        const token = await getIdToken(user, true)
        return {
          authGeneration,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      }
    } catch (error) {
      console.error('Error getting token:', error)
      router.navigate(['/login'], {
        queryParams: {
          error: 'token_error',
        },
      })
    }

    return { authGeneration }
  })

  return {
    link: ApolloLink.from([
      errorLink,
      auth,
      httpLink.create({ uri: environment.graphqlUrl }),
    ]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
      },
      query: {
        fetchPolicy: 'no-cache',
      },
      mutate: {
        fetchPolicy: 'no-cache',
      },
    },
  }
}

export const graphqlProvider: ApplicationConfig['providers'] = [
  Apollo,
  {
    provide: APOLLO_OPTIONS,
    useFactory: apolloOptionsFactory,
  },
]
